/* unplugin-vue-components disabled */import script from "./ChatSession.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSession.vue?vue&type=script&setup=true&lang=js"

import "./ChatSession.vue?vue&type=style&index=0&id=060284a8&lang=stylus"

const __exports__ = script;

export default __exports__